import React, { useContext, useState } from "react";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { useHistory, useLocation } from "react-router-dom";

import "./Login.css";
import Logo from "../../assets/images/logo.png";
import Screenshot1 from "../../assets/images/ff-screenshot-1.png";
import Screenshot2 from "../../assets/images/ff-screenshot-2.png";
import { AuthenticationContext } from "../../auth/AuthProvider";
import Navigation from "../../components/Navigation/Navigation";
import OrdersDemo from "../Orders/Demo/Demo";
import SignInForm from "./SignInForm";
import SignUpForm from "./SignUpForm";
import VerifyEmail from "./VerifyEmail";
import ManualReview from "./ManualReview";

const Login = (props) => {
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const authc = useContext(AuthenticationContext);
  const xsSize = useMediaQuery(theme.breakpoints.only("xs"));
  const smSize = useMediaQuery(theme.breakpoints.only("sm"));
  /* const mdSize = useMediaQuery(theme.breakpoints.only("md")); */

  const singUpMode = location?.search?.includes("signup");
  const userSession = authc.user ? JSON.parse(authc.user) : null;

  const [showSignUp, setShowSignUp] = useState(false);
  const [faceReady, setFaceReady] = useState(true);
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);
  const [showManualReview, setShowManualReview] = useState(false);

  const handleSwitchToSignUp = () => {
    setFaceReady(false);
    setShowSignUp(true);
    setTimeout(() => setFaceReady(true), 620);
  };

  const handleSwitchToSignIn = () => {
    if (singUpMode) {
      history.replace({ pathname: "/", search: "" });
    }
    setFaceReady(false);
    setShowSignUp(false);
    setTimeout(() => setFaceReady(true), 620);
  };

  if (
    authc.user &&
    !Boolean(userSession?.user?.needs_email_verified) &&
    !Boolean(userSession?.user?.needs_manual_review)
  ) {
    return <Navigation />;
  } else if (window.location && window.location.href.includes("/demo/")) {
    return <OrdersDemo {...props} />;
  }

  if (!showVerifyEmail) {
    if (
      (window.location && window.location.href.includes("/verify/")) ||
      (authc.user && Boolean(userSession?.user?.needs_email_verified))
    ) {
      setShowVerifyEmail(true);
      setShowSignUp(true);
    }
  }

  if (
    authc.user &&
    !showManualReview &&
    userSession?.user?.needs_email_verified === false &&
    Boolean(userSession?.user?.needs_manual_review)
  ) {
    setShowManualReview(true);
    setShowSignUp(true);
  }

  if (!showSignUp && singUpMode) {
    handleSwitchToSignUp();
  }

  return (
    <div className={`login${showSignUp ? " show-signup" : ""}`}>
      {/* sign-up panel — revealed when the overlay slides to the right */}
      <div className="signup-panel">
        {showVerifyEmail ? (
          <VerifyEmail />
        ) : showManualReview ? (
          <ManualReview />
        ) : (
          <>
            {xsSize || smSize ? (
              <img src={Logo} alt="logo" height="150" />
            ) : (
              <></>
            )}
            <SignUpForm
              onSwitchToSignIn={handleSwitchToSignIn}
              onRegister={authc.register}
            />
          </>
        )}
      </div>

      {/* sign-in panel */}
      <div className="signin-panel">
        {xsSize || smSize ? <img src={Logo} alt="logo" height="150" /> : <></>}
        <SignInForm onSwitchToSignUp={handleSwitchToSignUp} />
      </div>

      {/* sliding overlay — covers the inactive form panel */}
      <div className={`overlay-panel ${showSignUp ? "right" : "left"}`}>
        <div
          className={`overlay-brand overlay-face ${!showSignUp && faceReady ? "overlay-face--in" : "overlay-face--out"}`}
        >
          <span className="brand-name">Friendly Foods</span>
          <img src={Logo} alt="Friendly Foods" className="brand-logo" />
        </div>
        <div
          className={`overlay-screenshots overlay-face ${showSignUp && faceReady ? "overlay-face--in" : "overlay-face--out"}`}
        >
          <span className="brand-name">Friendly Foods</span>
          <div className="screenshots-stack">
            <img
              src={Screenshot1}
              alt="App screenshot 1"
              className="screenshot screenshot--back"
            />
            <img
              src={Screenshot2}
              alt="App screenshot 2"
              className="screenshot screenshot--front"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
